import { BuildingDTO } from "./building";
import { FileLog } from "./file";
import { MeterDto } from "./meter";
import { UnitDTO } from "./unit";

export enum SewageType {
  SEPARATED = 'Gescheiden',
  COMBINED = 'Gecombineerd',
  UNKNOWN = 'Onbekend'
}

export enum ConnectionType {
  OWN = 'Eigen aansluiting',
  NEIGHBOR = 'Aansluiting via buur',
  UNKNOWN = 'Onbekend'
}

export enum PipeMaterial {
  PP = 'PP',
  PVC = 'PVC',
  PE = 'PE',
  GRES = "Grès",
  CONCRETE = 'Beton',
  ETERNIT = 'Eternit',
  UNKNOWN = 'Onbekend'
}

export enum InfiltrationSystemPresent {
  OK = 'Aanwezig',
  NOT_REQUIRED = 'Niet aanwezig en niet verplicht',
  NOT_OK = 'Niet aanwezig en verplicht',
  UNKNOWN = 'Onbekend'
}

export enum InfiltrationSystemType {
  INFILTRATION_WELL = 'Infiltratieput',
  INFILTRATION_CRATES = 'Infiltratiekratten',
  UNKNOWN = 'Onbekend'
}

export enum TankMaterial {
  CONCRETE = 'Beton',
  PLASTIC = 'Kunststof',
  UNKNOWN = 'Onbekend'
}

export enum WaterSoftenerType {
  SALT_BASED = 'Zout',
  ELECTROLYSIS = 'Electrolyse',
  UNKNOWN = 'Onbekend'
}

export enum WaterPressureSufficientStatus {
  OK = 'Ja',
  NOT_OK = 'Nee',
  UNKNOWN = 'Onbekend'
}

export enum PipesInsulatedStatus {
  OK = 'Ja',
  NOT_OK = 'Nee',
  UNKNOWN = 'Onbekend'
}

export enum WaterSoftenerStatus {
  OK = 'Aanwezig',
  NOT_REQUIRED = 'Niet aanwezig en niet nodig',
  NOT_OK = 'Niet aanwezig, maar te voorzien',
  UNKNOWN = 'Onbekend'
}

export enum SepticTankPresent {
  OK = 'Aanwezig',
  NOT_REQUIRED = 'Niet aanwezig en niet verplicht',
  NOT_OK = 'Niet aanwezig en verplicht',
  UNKNOWN = 'Onbekend'
}

export enum RainWaterTankPresent {
  OK = 'Aanwezig',
  NOT_REQUIRED = 'Niet aanwezig en niet verplicht',
  NOT_OK = 'Niet aanwezig en verplicht',
  UNKNOWN = 'Onbekend'
}

export enum GreaseSeperatorPresent {
  OK = 'Aanwezig',
  NOT_REQUIRED = 'Niet aanwezig en niet verplicht',
  NOT_OK = 'Niet aanwezig en verplicht',
  UNKNOWN = 'Onbekend'
}

export enum WaterPressureIncreaseSystemPresent {
  OK = 'Aanwezig',
  NOT_REQUIRED = 'Niet aanwezig en niet nodig',
  NOT_OK = 'Niet aanwezig, maar te voorzien',
  UNKNOWN = 'Onbekend'
}


export type WaterUnitInfoDto = {
  id: number;
  unit: UnitDTO;
  connectedTo: WaterConnectedTo;
  remarks: string;
  waterMeters: MeterDto[];
}

export enum WaterConnectedTo {
  PRIVATE_SYSTEM = 'Eigen systeem',
  CENTRAL_SYSTEM = 'Centraal systeem',
  UNKNOWN = 'Onbekend'
}


export type WaterBuildingInfoDto = {
  id: number;
  building: BuildingDTO;
  remarks: string;
  easements: string;
  sewageType: SewageType;
  connectionType: ConnectionType;
  pipeMaterial: PipeMaterial;
  mainDrainDiameter: number;
  sewagePlanFileLogId: string;
  sewagePlanFileLog: FileLog;
  infiltrationSystemPresent: InfiltrationSystemPresent;
  infiltrationSystemType: InfiltrationSystemType;
  rainWaterTankPresent: RainWaterTankPresent;
  rainwaterTankVolume: number;
  rainwaterTankLocation: string;
  rainwaterTankMaterial: TankMaterial;
  septicTankPresent: SepticTankPresent;
  septicTankVolume: number;
  septicTankLocation: string;
  sewageRemarks: string;
  waterSupplyRemarks: string;
  septicTankMaterial: TankMaterial;
  greaseSeparatorPresent: GreaseSeperatorPresent;
  greaseSeparatorLocation: string;
  sewageInspectionCertificateFileLogId: string;
  sewageInspectionCertificateFileLog: FileLog;
  waterInstallationCertificateFileLogId: string;
  waterInstallationCertificateFileLog: FileLog;
  waterPressureSufficientStatus: WaterPressureSufficientStatus;
  waterMeters: MeterDto[];
  pipesInsulatedStatus: PipesInsulatedStatus;
  waterSoftenerStatus: WaterSoftenerStatus;
  mainValveLocation: string;
  waterPhValue: string;
  waterPressureIncreaseSystemPresent: WaterPressureIncreaseSystemPresent
  waterSoftenerPresent: boolean;
  waterSoftenerBrand: string;
  waterSoftenerType: WaterSoftenerType;
  waterSoftenerYear: number;
  waterSoftenerCapacity: number;
  // Add additional fields or relations here as needed
}
